import * as types from '../constants/ActionTypes'
import * as notifications from '../constants/notifications'

export const showNotification = (message, kind) => ({
  type: types.SHOW_NOTIFICATION,
  message,
  kind,
})

export const notifySuccess = message => showNotification(message, notifications.SUCCESS)
export const notifyFailure = message => showNotification(message, notifications.ERROR)



// WEBPACK FOOTER //
// ./src/actions/notifications.ts